/// <amd-module name="SuiteCommerce.Blog.EmptyState.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.EmptyState.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EmptyStateModel = void 0;
    var EmptyStateModel = /** @class */ (function (_super) {
        __extends(EmptyStateModel, _super);
        function EmptyStateModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(EmptyStateModel.prototype, "label", {
            get: function () {
                return this.get('label');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EmptyStateModel.prototype, "message", {
            get: function () {
                return this.get('message');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EmptyStateModel.prototype, "actionButtonLabel", {
            get: function () {
                return this.get('actionButtonLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EmptyStateModel.prototype, "actionButtonUrl", {
            get: function () {
                return this.get('actionButtonUrl');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EmptyStateModel.prototype, "showSuggestions", {
            get: function () {
                return this.get('showSuggestions');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EmptyStateModel.prototype, "suggestionListTitle", {
            get: function () {
                return this.get('suggestionListTitle');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EmptyStateModel.prototype, "searchSuggestionOptions", {
            get: function () {
                return this.get('searchSuggestionOptions');
            },
            enumerable: false,
            configurable: true
        });
        return EmptyStateModel;
    }(Backbone_1.Model));
    exports.EmptyStateModel = EmptyStateModel;
});
